class Cart extends HTMLElement {
  constructor() {
    super();
    this.handleToggleDrawerCart();
    this.handleQuantityFields();
    this.handleBundleAddToCart();
    this.handleAddToCart();
    this.handleFreeProductToggle();
  }
  
  handleToggleDrawerCart() {
    document.querySelectorAll('.js-open-drawer-cart').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const drawer = document.querySelector('.js-drawer-cart');
        if (!drawer) return;

        drawer.classList.add('display');
        document.body.style.overflow = 'hidden';

        setTimeout(() => {
          drawer.classList.add('active');
        }, 50);
      });
    });

    document.querySelectorAll('.js-close-drawer-cart').forEach(button => {
      button.addEventListener('click', (event) => {
        event.preventDefault();
        const drawer = document.querySelector('.js-drawer-cart');
        if (!drawer) return;

        drawer.classList.add('closing');

        setTimeout(() => {
          drawer.classList.remove('active', 'closing', 'display');
          document.body.style.overflow = 'visible';
        }, 300);
      });
    });
  }

  handleQuantityFields() {
    const self = this;
    document.body.addEventListener('click', (event) => {
			const target = event.target.closest('.js-change-quantity');
			if (!target) return;

      event.preventDefault();
  
      target.classList.add('loading');
			  
			const variantId = parseInt(target.getAttribute('data-variant-id'), 10);
			let quantity = parseInt(target.getAttribute('data-quantity'), 10);
      const container = target.closest('.js-quantity-fields');

      container.querySelector('.js-quantity-minus').setAttribute('data-quantity', quantity - 1);
      container.querySelector('.js-quantity-plus').setAttribute('data-quantity', quantity + 1);

      const cartItem = container.closest('.js-cart-item');
      cartItem.style.height = `${cartItem.offsetHeight}px`;
			  
      var formData = new FormData();
      formData.append("updates[" + variantId + "]", quantity);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(response => {
        self.toggleFreeProductVisibility(response);
        document.querySelectorAll('.js-change-quantity').forEach(el => el.classList.remove('loading'));
				const subtotalElement = document.querySelector('.js-subtotal-price');
				if (subtotalElement) {
					subtotalElement.innerHTML = Shopify.formatMoney(response.total_price);
				}
        
        if (quantity < 1) {
          cartItem.classList.add('hide-item');
          setTimeout(() => {
            cartItem.classList.add('hidden');
            if (response.total_price === 0) {
              document.querySelector('.js-cart-content').classList.add('drawer-cart__content--empty');
            }
          }, 300);
        } else {
          container.querySelector('.js-quantity-field-input').value = quantity;
        }
        
        const freeDelivery = document.querySelector('.js-free-delivery');
        if (freeDelivery) {
          let width = 0;
          const limit = parseInt(freeDelivery.getAttribute('data-limit'));
          let price = Shopify.formatMoney(0);
          
          if (response.total_price >= limit) {
            width = 100;
            freeDelivery.classList.add('active');
          } else {
            freeDelivery.classList.remove('active');
            if (response.total_price > 0) {
              width = (response.total_price / limit) * 100;
              price = Shopify.formatMoney(limit - response.total_price);
              document.querySelector('.js-cart-spend-more-money').innerHTML =
                freeDelivery.getAttribute('data-spend-more-text').replace('[price]', price);
            }
          }
          document.querySelector('.js-free-delivery-bar').style.width = `${width}%`;
        }
        
				document.querySelectorAll('.js-cart-counter').forEach(cartCounter => {
				  cartCounter.innerHTML = '[' + response.item_count + ']';
				  cartCounter.setAttribute('data-counter', response.item_count);
				});

        document.querySelectorAll('.js-cart-counter-2').forEach(cartCounter => {
          cartCounter.innerHTML = response.item_count;
          cartCounter.setAttribute('data-counter', response.item_count);
        });
      })
      .catch(error => {
        alert(error.message || 'Error');
        document.querySelectorAll('.js-change-quantity').forEach(el => el.classList.remove('loading'));
      });
    });
  }

  handleBundleAddToCart() {
    const self = this;
    document.body.addEventListener('click', (event) => {
      const bundleBtn = event.target.closest('.js-add-to-cart-bundle');
      if (!bundleBtn) return;

      event.preventDefault();
      bundleBtn.getAttribute("data-adding-text") && (bundleBtn.innerHTML = bundleBtn.getAttribute("data-adding-text"));
      bundleBtn.classList.add('loading');

      const bundleProducts = document.querySelectorAll('.js-bundle-product');
      const items = [];

      bundleProducts.forEach(bundle => {
        const select = bundle.querySelector('select[name="id"]');
        if (select) {
          const selectedOption = select.querySelector('option:checked');
          const variantId = selectedOption?.value;
          const quantity = 1;

          if (variantId) {
            items.push({
              id: parseInt(variantId, 10),
              quantity: parseInt(quantity, 10)
            });
          }
        }
      });

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({ items })
      })
      .then(async response => {
        if (!response.ok) {
          const errorData = await response.json();
          const error = new Error(errorData.description || 'Something went wrong');
          error.status = response.status;
          throw error;
        }
        return response.json();
      })
      .then(response => {
        response.items.forEach(responseItem => {
          const variantId = responseItem.variant_id;
          const image = responseItem.image;
          let cartItem = document.querySelector(`.js-cart-item[data-variant-id='${variantId}']:not(.hidden)`);

          if (cartItem) {
            let quantityField = cartItem.querySelector(".js-quantity-field-input");
            let quantityMinus = cartItem.querySelector(".js-quantity-minus");
            let quantityPlus = cartItem.querySelector(".js-quantity-plus");

            quantityField.value = responseItem.quantity;
            quantityMinus.setAttribute("data-quantity", responseItem.quantity - 1);
            quantityPlus.setAttribute("data-quantity", responseItem.quantity + 1);
          } else {
            let item = `
            <li class="cart-item d-flex js-cart-item" data-variant-id="${variantId}">
              <div class="cart-item__image">
                <a href="${responseItem.url}">
                  <img src="${image}" width="668px" height="768px" alt="${responseItem.product_title}" />
                </a>
              </div>
              <div class="cart-item__details">
                <div class="cart-item__title text-cta"><a href="${responseItem.url}">${responseItem.product_title}</a></div>
                <div class="cart-item__price text-cta">${Shopify.formatMoney(responseItem.final_price)}</div>
                ${(responseItem.options_with_values || [])
                  .filter(option => option.name !== 'Title')
                  .map(option => `<div class="cart-item__option">${option.name}: ${option.value}</div>`)
                  .join('')}
                <div class="cart-product__quantity-and-delete d-flex align-items-center js-quantity-fields">
                  <div class="cart-product__quantity-field">
                    <div class="quantity-field__minus">
                      <a href="#" class="js-change-quantity js-quantity-minus" data-variant-id="${variantId}" data-quantity="${responseItem.quantity - 1}">-</a>
                    </div>
                    <input type="text" value="${responseItem.quantity}" class="quantity-field__input js-quantity-field-input" disabled="disabled" />
                    <div class="quantity-field__plus">
                      <a href="#" class="js-change-quantity js-quantity-plus" data-variant-id="${variantId}" data-quantity="${responseItem.quantity + 1}">+</a>
                    </div>
                  </div>
                  <div class="cart-item__delete">
                    <a href="#" class="js-change-quantity" data-variant-id="${variantId}" data-quantity="0">Remove</a>
                  </div>
                </div>
              </div>
            </li>`;
            document.querySelector(".js-cart-items").insertAdjacentHTML("beforeend", item);
            if (typeof initializeObservers === "function") {
              initializeObservers();
            }
          }
        });

        return fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json());
      })
      .then(cart => {
        self.toggleFreeProductVisibility(cart);

        document.querySelectorAll(".js-change-quantity").forEach(el => el.classList.remove("loading"));
        const subtotalElement = document.querySelector('.js-subtotal-price');
        if (subtotalElement) {
          subtotalElement.innerHTML = Shopify.formatMoney(cart.total_price);
        }
        
        let freeDeliveryElement = document.querySelector(".js-free-delivery");
        if (freeDeliveryElement) {
          let width = 0;
          let limit = parseInt(freeDeliveryElement.getAttribute("data-limit"));
          let price = Shopify.formatMoney(0);

          if (cart.total_price >= limit) {
            width = 100;
            freeDeliveryElement.classList.add("active");
          } else {
            freeDeliveryElement.classList.remove("active");
            if (cart.total_price > 0) {
              width = (cart.total_price / limit) * 100;
              price = Shopify.formatMoney(limit - cart.total_price);
              document.querySelector(".js-cart-spend-more-money").innerHTML =
                  freeDeliveryElement.getAttribute("data-spend-more-text").replace("[price]", price);
            }
          }
          document.querySelector(".js-free-delivery-bar").style.width = width + "%";
        }

        document.querySelector(".js-cart-content")?.classList.remove("drawer-cart__content--empty");
        document.querySelectorAll('.js-cart-counter').forEach(cartCounter => {
          cartCounter.innerHTML = '[' + cart.item_count + ']';
          cartCounter.setAttribute('data-counter', cart.item_count);
        });
        document.querySelectorAll('.js-cart-counter-2').forEach(cartCounter => {
          cartCounter.innerHTML = cart.item_count;
          cartCounter.setAttribute('data-counter', cart.item_count);
        });
        document.querySelector('.js-drawer-cart')?.classList.add('display');
        setTimeout(() => {
          document.querySelector('.js-drawer-cart')?.classList.add('active');
        }, 50);
        document.querySelectorAll('.js-add-to-cart-bundle').forEach(button => {
          const originalText = button.getAttribute('data-original-text');
          if (originalText) {
            button.textContent = originalText;
          }
        });
        document.querySelectorAll('.js-product-size-1, .js-product-size-2, .js-product-size-3, .js-open-mobile-options').forEach(sizeElement => {
          sizeElement.classList.remove('active');
        });
        document.querySelectorAll('.js-product-grid-item-hover').forEach(hoverElement => {
          hoverElement.classList.remove('step-1', 'step-2', 'step-3');
        });
      })
      .catch(error => {
        alert(error?.message || 'Unexpected error');
        window.location.reload();
      });
    });
  }

  handleAddToCart() {
    const self = this;
		document.body.addEventListener("click", function (event) {
      const target = event.target.closest(".js-add-to-cart");
	    if (!target) return;

      document.querySelectorAll('.js-product-grid-item.display, .js-product-grid-item.show, .js-product-grid-item.deactivate')
        .forEach(el => {
          el.classList.add('deactivate');

          setTimeout(() => {
            el.classList.remove("show", "display", "deactivate");
          }, 300);
        });

	    event.preventDefault();

      const preorderText = target?.getAttribute('data-preorder-text') || '';
      const isPreorder = preorderText && target?.textContent.includes(preorderText);

      if(isPreorder) {
        target.classList.add("pre-order");
      }

      if (!target.classList.contains('js-add-to-cart-2')) {
        target.getAttribute("data-adding-text") && (target.innerHTML = target.getAttribute("data-adding-text"));
        target.classList.add("loading");
      }

	    let quantity, id = {};

      let productId = target.getAttribute("data-product-id");
      let productElement = document.querySelector(`.js-product[data-product-id='${productId}'], .js-product-grid-item[data-product-id='${productId}'], .js-co-ordinating-product[data-product-id='${productId}']`);
      quantity = productElement?.querySelector(".js-quantity-field")?.value || 1;
      if (isNaN(quantity) || !quantity) quantity = 1;
      id = productElement ? productElement.querySelector(`#product-select-${productId}`).value : null;

      let productElements = document.querySelectorAll(`.js-product[data-product-id='${productId}'], .js-product-grid-item[data-product-id='${productId}'], .js-co-ordinating-product-2[data-product-id='${productId}']`);
      productElements.forEach(el => {
        el.classList.add("with-adding");
      });

      let image = target.getAttribute("data-featured-image") || response.image;

      let formData = {
       'items': [{
          'id': parseInt(id, 10),
          'quantity': parseInt(quantity, 10)
        }]
      };

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      })
      .then(async response => {
        if (!response.ok) {
          const errorData = await response.json();
          const error = new Error(errorData.description || 'Something went wrong');
          error.status = response.status;
          throw error;
        }
        return response.json();
      })
      .then(response => {
        response = response.items.find(item => item.id === parseInt(id, 10));
        let variantId = response.variant_id;
        let cartItem = document.querySelector(`.js-cart-item[data-variant-id='${variantId}']:not(.hidden)`);

        if (cartItem) {
          let quantityField = cartItem.querySelector(".js-quantity-field-input");
          let quantityMinus = cartItem.querySelector(".js-quantity-minus");
          let quantityPlus = cartItem.querySelector(".js-quantity-plus");

          quantityField.value = response.quantity;
          quantityMinus.setAttribute("data-quantity", response.quantity - 1);
          quantityPlus.setAttribute("data-quantity", response.quantity + 1);
        } else {
          let quantityMinus = response.quantity - 1;
          let quantityPlus = response.quantity + 1;
          if(response.image) {
            const img = new Image();
            img.src = response.image;
          }

					let item = `
					<li class="cart-item d-flex js-cart-item" data-variant-id="${response.variant_id}">
					  <div class="cart-item__image">
					    <a href="${response.url}">
                <img src="${image}" width="668px" height="768px" alt="${response.product_title}" />
					    </a>
					  </div>
					  <div class="cart-item__details">
              <div class="cart-item__title text-cta"><a href="${response.url}">${response.product_title}</a></div>
              <div class="cart-item__price text-cta">${Shopify.formatMoney(response.final_price)}</div>
              ${(response.options_with_values || [])
                .filter(option => option.name !== 'Title')
                .map(option => `<div class="cart-item__option">${option.name}: ${option.value}</div>`)
                .join('')}
					    <div class="cart-product__quantity-and-delete d-flex align-items-center js-quantity-fields">
					      <div class="cart-product__quantity-field">
					        <div class="quantity-field__minus">
					          <a href="#" class="js-change-quantity js-quantity-minus" data-variant-id="${response.variant_id}" data-quantity="${response.quantity - 1}">-</a>
					        </div>
					        <input type="text" value="${response.quantity}" class="quantity-field__input js-quantity-field-input" disabled="disabled" />
					        <div class="quantity-field__plus">
					          <a href="#" class="js-change-quantity js-quantity-plus" data-variant-id="${response.variant_id}" data-quantity="${response.quantity + 1}">+</a>
					        </div>
					      </div>
                ${isPreorder ? `<div class="cart-product__pre-order text-cta">${preorderText}</div>` : ''}
					      <div class="cart-item__delete">
					        <a href="#" class="js-change-quantity" data-variant-id="${response.variant_id}" data-quantity="0">Remove</a>
					      </div>
					    </div>
					  </div>
					</li>`;
          document.querySelector(".js-cart-items").insertAdjacentHTML("beforeend", item);
          if (typeof initializeObservers === "function") {
            initializeObservers();
          }
        }

        return fetch(window.Shopify.routes.root + 'cart.js').then(response => response.json());
	    })
	    .then(cart => {
        self.toggleFreeProductVisibility(cart);

        document.querySelectorAll(".js-change-quantity").forEach(el => el.classList.remove("loading"));
				const subtotalElement = document.querySelector('.js-subtotal-price');
				if (subtotalElement) {
					subtotalElement.innerHTML = Shopify.formatMoney(cart.total_price);
				}
        
        let freeDeliveryElement = document.querySelector(".js-free-delivery");
        if (freeDeliveryElement) {
          let width = 0;
          let limit = parseInt(freeDeliveryElement.getAttribute("data-limit"));
          let price = Shopify.formatMoney(0);

          if (cart.total_price >= limit) {
            width = 100;
            freeDeliveryElement.classList.add("active");
          } else {
            freeDeliveryElement.classList.remove("active");
            if (cart.total_price > 0) {
              width = (cart.total_price / limit) * 100;
              price = Shopify.formatMoney(limit - cart.total_price);
              document.querySelector(".js-cart-spend-more-money").innerHTML =
                  freeDeliveryElement.getAttribute("data-spend-more-text").replace("[price]", price);
            }
          }
          document.querySelector(".js-free-delivery-bar").style.width = width + "%";
        }

        document.querySelector(".js-cart-content")?.classList.remove("drawer-cart__content--empty");
				document.querySelectorAll('.js-cart-counter').forEach(cartCounter => {
				  cartCounter.innerHTML = '[' + cart.item_count + ']';
				  cartCounter.setAttribute('data-counter', cart.item_count);
				});
        document.querySelectorAll('.js-cart-counter-2').forEach(cartCounter => {
          cartCounter.innerHTML = cart.item_count;
          cartCounter.setAttribute('data-counter', cart.item_count);
        });
        document.querySelector('.js-drawer-cart')?.classList.add('display');
        setTimeout(() => {
          document.querySelector('.js-drawer-cart')?.classList.add('active');
        }, 50);
        document.querySelectorAll('.js-add-to-cart:not(.js-add-to-cart-2)').forEach(button => {
          const preorderText = button.getAttribute('data-preorder-text');
          const originalText = button.getAttribute('data-original-text');
          if (button.classList.contains('pre-order') && preorderText) {
            button.textContent = preorderText;
          } else if (originalText) {
            button.textContent = originalText;
          }
          button.classList.remove('pre-order');
        });
        document.querySelectorAll('.js-product-size-1, .js-product-size-2, .js-product-size-3, .js-open-mobile-options').forEach(sizeElement => {
          sizeElement.classList.remove('active');
        });
        document.querySelectorAll('.js-product-grid-item-hover').forEach(hoverElement => {
          hoverElement.classList.remove('step-1', 'step-2', 'step-3');
        });
        productElements.forEach(el => {
          el.classList.remove("with-adding");
        });
	    })
      .catch(async (error) => {
        let message = 'Unexpected error';

        try {
          const text = await error.text();
          const json = JSON.parse(text);
          if (json && json.description) {
            message = json.description;
          }
        } catch (e) {
          message = error.message || 'Something went wrong';
        }

        alert(message);
        window.location.reload();
      });
		});
  }

  handleFreeProductToggle() {
    document.body.addEventListener('click', (event) => {
      const target = event.target.closest('.js-free-product');
      if (!target) return;

      event.preventDefault();

      target.classList.toggle('active');

      const textarea = document.querySelector("textarea[name='note']");
      if (!textarea) return;

      const note = target.classList.contains('active')
        ? target.getAttribute('data-cart-note') || ''
        : '';

      textarea.value = note;

      const formData = new FormData();
      formData.append("note", note);

      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        body: formData
      })
      .then(response => response.json())
      .then(data => {
        console.log('Cart note updated:', data.note);
      })
      .catch(error => {
        console.error('Error updating cart note:', error);
      });
    });
  }

  toggleFreeProductVisibility(cart) {
    const freeProductEl = document.querySelector('.js-free-product');
    if (!freeProductEl) return;

    const hasOnlyGiftCard = cart.items.length === 1 && cart.items[0].product_title.toLowerCase().includes('gift card');

    if (hasOnlyGiftCard) {
      freeProductEl.classList.add('d-none');
      freeProductEl.classList.remove('d-flex');
    } else {
      freeProductEl.classList.remove('d-none');
      freeProductEl.classList.add('d-flex');
    }
  }
}

customElements.define('drawer-cart', Cart);